import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Thongkethue from "components/Thongke/Thongtinthue/Thongtinthue.js";
export default function Tklaixe() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Tra cứu thông tin về thuế",
            tabContent: <Thongkethue />,
          },
        ]}
      />
    </div>
  );
}
